import Component from "../abstracts/Component";

export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      main: '#contactUsForm',
      subject: '.js-contact-subject',
      returns: '.js-subject-returns',
      orders: '.js-subject-orders',
      blocks: '.js-subject',
      subjectCode: '.js-subject-code',
      contactUs: '.contactUsPageGReCaptchaChallange'
    }
  }

  constructor() {
    super()
  }

  submitForm(data, url) {
    return $.ajax({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  showAdditionalData(index) {
    const ordersBlock = document.querySelector(this.SELECTORS.orders);
    const returnsBlock = document.querySelector(this.SELECTORS.returns);
    switch (index) {
      case 8:
        (ordersBlock ? ordersBlock.classList.add('d-none') : false);
        (returnsBlock ? returnsBlock.classList.remove('d-none') : false);
        break;
      case 2:
        (returnsBlock ? returnsBlock.classList.add('d-none') : false);
        (ordersBlock ? ordersBlock.classList.remove('d-none') : false);
        break;
      default:
        (ordersBlock ? ordersBlock.classList.add('d-none') : false);
        (returnsBlock ? returnsBlock.classList.add('d-none') : false);
    }
    document.querySelector(this.SELECTORS.subjectCode).value = index;
  }

  bindSubject() {
    // context
    let ctx = this;
    this.$on('change', ({event}) => {
      //
      let index =  event.currentTarget[event.currentTarget.selectedIndex].getAttribute('data-subject-id');
      this.showAdditionalData(parseInt(index));
      //
      ctx.manageBlocks();
    }, 'body', this.SELECTORS.subject);
  }

  manageBlocks() {
    let blocks = $(this.SELECTORS.main).find(this.SELECTORS.blocks);
    if (blocks === null) return false;
    blocks.each(function() {
      let $input = $(this).find('input, select');
      if ($(this).hasClass('d-none')) {
        $input.prop('disabled', true);
      } else {
        $input.prop('disabled', false);
      }
    })
  }

  bindSubmit() {
    // context
    let ctx = this;
    this.$on('submit', ({event}) => {
      event.preventDefault();
      if (window.RecapchaComponent && !window.RecapchaComponent.getResponseFromWidget('contactUsPage')) {
        // User have not completed the challenge
        return;
      }
      if($(this.SELECTORS.subject).find(':selected').data('subject-id') == 8) {
        if($("input[name='datePick']").val() == '') {
          $("input[name='datePick']").prop("disabled", true);
        }
      }
      var disabled = $('#contactUsForm').find('select:disabled').removeAttr('disabled');
      const form = $(event.target).serialize();
      disabled.attr('disabled','disabled');

      const action = event.currentTarget.getAttribute('action');
      //
      event.target.classList.add('sending');
      document.querySelector(this.SELECTORS.contactUs).setAttribute('disabled', 'disabled');
      // data.concat(`&${this.getSubjectCode()}`);
      this.submitForm(form, action).then(res => {
        // get returned html
        const responseHtml = new DOMParser().parseFromString(res, 'text/html');
        // errors check
        if (responseHtml.querySelector('.error-msg') ) {
          // replace form
          event.currentTarget.parentElement.querySelector('.form-content').innerHTML = responseHtml.querySelector('.form-content').innerHTML;
          ctx.manageBlocks();
        } else {
          // show than you msg
          event.currentTarget.parentElement.innerHTML = res;
        }
        // launch event
        this.$emit(this.$customEvents.FORM_EVENTS.formReplaced, {event: event});
        //
        event.target.classList.remove('sending');

      });
    }, 'body', this.SELECTORS.main);
  }

  render() {
    this.log('rendering...');
    this.bindSubmit();
    if (document.querySelector(this.SELECTORS.returns) || document.querySelector(this.SELECTORS.orders)) {
      this.bindSubject();
      if($(this.SELECTORS.subject)) {
        $(this.SELECTORS.subject).trigger('change');
      }
    }
  }
}
